/**
 * React Starter Kit for Firebase and GraphQL
 * https://github.com/kriasoft/react-firebase-starter
 * Copyright (c) 2015-present Kriasoft | MIT License
 */

/* @flow */

export { default } from './Link';



// WEBPACK FOOTER //
// ./src/components/Link/index.js